var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 128,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 384,
    style: {
      fill: "#4173CD"
    },
    width: 512,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M0,512l253.284-249.017c3.621-3.57,3.621-10.397,0-13.966L0,0V512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M63.777,256c0-42.49,27.774-78.442,66.144-90.824c2.017-0.651,1.736-3.596-0.365-3.871   c-3.949-0.518-7.973-0.796-12.065-0.796C64.753,160.509,22,203.262,22,256s42.753,95.491,95.491,95.491   c4.092,0,8.115-0.278,12.065-0.796c2.102-0.275,2.382-3.22,0.365-3.871C91.552,334.442,63.777,298.49,63.777,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.41,183.064l2.629,7.882l8.308,0.064c1.076,0.008,1.522,1.381,0.656,2.02l-6.684,4.936   l2.506,7.922c0.324,1.026-0.843,1.874-1.718,1.248l-6.759-4.831l-6.759,4.831c-0.875,0.626-2.043-0.223-1.718-1.248l2.506-7.922   l-6.684-4.936c-0.865-0.639-0.419-2.012,0.656-2.02l8.308-0.064l2.629-7.882C128.627,182.043,130.07,182.043,130.41,183.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.41,223.006l2.629,7.882l8.308,0.064c1.076,0.008,1.522,1.381,0.656,2.02l-6.684,4.936   l2.506,7.922c0.324,1.026-0.843,1.874-1.718,1.248l-6.759-4.831l-6.759,4.831c-0.875,0.626-2.043-0.223-1.718-1.248l2.506-7.922   l-6.684-4.936c-0.865-0.639-0.419-2.012,0.656-2.02l8.308-0.064l2.629-7.882C128.627,221.986,130.07,221.986,130.41,223.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.41,262.949l2.629,7.882l8.308,0.064c1.076,0.008,1.522,1.381,0.656,2.02l-6.684,4.936   l2.506,7.922c0.324,1.026-0.843,1.874-1.718,1.248l-6.759-4.831l-6.759,4.831c-0.875,0.626-2.043-0.223-1.718-1.248l2.506-7.922   l-6.684-4.936c-0.865-0.639-0.419-2.012,0.656-2.02l8.308-0.064l2.629-7.882C128.627,261.928,130.07,261.928,130.41,262.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.41,302.891l2.629,7.882l8.308,0.064c1.076,0.008,1.522,1.381,0.656,2.02l-6.684,4.936   l2.506,7.922c0.324,1.026-0.843,1.874-1.718,1.248l-6.759-4.831l-6.759,4.831c-0.875,0.626-2.043-0.223-1.718-1.248l2.506-7.922   l-6.684-4.936c-0.865-0.639-0.419-2.012,0.656-2.02l8.308-0.064l2.629-7.882C128.627,301.871,130.07,301.871,130.41,302.891z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.687a8a504f69c888a3bdaf395e43af83.svg";
export { ForwardRef as ReactComponent };